<template>
  <div class="video-component-wrap" v-if="frame" :class="classes">
    <video @click="$emit('select')" ref="videoRef" :mute="mute">
      Видео не поддерживается вашим браузером
    </video>
    <div v-if="!videoActive" class="vm-video-avatar">
      <template v-if="frame.avatar">
        <img :src="frame.avatar" style="width:100%; height:100%; border-radius:50%; object-fit: scale-down;"/>
      </template>
      <template v-else>
        {{ initials }}
      </template>
    </div> 
    <div class="video-component-username">
      {{ frame.username }}
    </div>
    <div @click="$emit('select')" class="vm-overlay"></div>
    <div class="action-bar">
      <button v-if="frame.streamManager.remote" @click="$emit('mute')" class="mute-button">
        <i class="material-icons">{{ !frame.mute ? 'volume_mute' : 'volume_off' }}</i>
      </button>
      <button v-if="fullscreen" @click="$emit('exitFullscreen')" class="mute-button">
        <i class="material-icons">fullscreen_exit</i>
      </button>
    </div>
    <div v-if="!hasAudio" class="status-bar">
      <i class="material-icons">mic_off</i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    frame: {
      lastName: String,
      firstName: String,
      streamManager: Object,
      username: String,
      speaking: Boolean,
      mute: Boolean,
      volume: Number,
      activeFrame: Boolean
    }
  },
  computed: {
    initials() {
      return this.frame.lastName.charAt(0) + this.frame.firstName.charAt(0);
    },
    videoActive() {
      return this.frame.streamManager.stream.videoActive;
    },
    classes() {
      return {
        'selected': this.frame.speaking,
        'large': this.large,
        'fullscreen': this.fullscreen,
        'active': this.active
      };
    },
    hasAudio() {
      return this.frame.streamManager.stream.hasAudio;
    },
    audioActive() {
      return this.frame.streamManager.stream.audioActive;
    }
  },
  data: () => ({
    mute: false
  }),
  watch: {
    frame(frame) {
      const ref = this.$refs.videoRef;
      frame.streamManager.addVideoElement(ref);
    },
    'frame.volume': function(volume) {
      this.$refs.videoRef.volume = volume / 100;
    }
  },
  created() {
    this.mute = this.large;
  },
  async mounted() {
    const ref = this.$refs.videoRef;
    await this.frame.streamManager.addVideoElement(ref);
    ref.play();
  },
};
</script>

<style scoped>
.video-component-wrap {
  position: relative;
  width: 100%;
}
.video-component-wrap.fullscreen {
  display: flex;
}
.video-component-wrap .video-component-username {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 4px 8px;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  font-size: 12px;
  line-height: 1;
}
.video-component-wrap.large .video-component-username {
  bottom: 4px;
  left: 4px;
  right: auto;
  font-size: 18px;
}
.video-component-wrap video {
  display: block;
  width: 100%;
  background-color: black;
  max-height: 100%;
}
.video-component-wrap.active .vm-overlay {
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0rem;
  border: 2px solid red;
}
.video-component-wrap.selected .vm-overlay {
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0rem;
  border: 2px solid rgb(161, 21, 255);
}
.status-bar {
  position: absolute;
  top: 3px;
  left: 3px;
  color: red;
}
.action-bar {
  position: absolute;
  top: 3px;
  right: 3px;
  display: flex;
}
.action-bar button {
  outline: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
  border-radius: 50%;
  border: 0;
  height: 32px;
  width: 32px;
}
.action-bar button:hover {
  background: rgba(0, 0, 0, 0.5);
}
.vm-video-avatar {
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0;
  margin: auto;
  display: flex;
  height: 60px;
  width: 60px;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  color: rgb(114, 56, 211);
  font-weight: 500;
  font-size: 20px;
}
.large .vm-video-avatar {
  height: 100px;
  width: 100px;
  font-size: 26px;
}
</style>